import React, {useCallback} from 'react'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Box} from '@vio/atlas/helpers/Box'
import {Text} from '@vio/atlas/Text'
import {Toggle} from '@vio/atlas/Toggle'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {PriceToggleRow} from '../../search/PriceToggleRow'
import {usePointsPriceDisplay} from '../hooks/usePointsPriceDisplay'
import {loyaltyMessages} from '../loyaltyMessages'

interface Props {
  /** Bordered row on every layout. Mobile is always a row. */
  asRow?: boolean
  /** DOM id; the AP renders two of these, so they need their own */
  id?: string
}

export const PointsPriceToggle = ({
  asRow = false,
  id = 'pointsPriceToggle'
}: Props) => {
  const {isMobile} = useDeviceLayout()
  const {isAvailable, isOn, setIsOn} = usePointsPriceDisplay()

  const handleChange = useCallback(() => {
    setIsOn(!isOn)
  }, [isOn, setIsOn])

  if (!isAvailable) return null

  const isRow = asRow || isMobile
  const labelId = `${id}-label`

  const label = (
    <Text variant={isRow ? 'labelS' : 'bodyS'} id={labelId}>
      <FormattedMessageWrapper {...loyaltyMessages.showPricesInPoints} />
    </Text>
  )

  const toggle = (
    <Toggle
      id={id}
      checked={isOn}
      onChange={handleChange}
      ariaLabelledBy={labelId}
    />
  )

  if (isRow)
    return (
      <PriceToggleRow>
        {label}
        {toggle}
      </PriceToggleRow>
    )

  return (
    <Box display="flex" gap="s200" alignItems="center">
      {label}
      {toggle}
    </Box>
  )
}
